import { AppBar, Menu, Tab } from "@mui/material";
import { StyledComponentProps, withStyles } from "@mui/styles";
import { FeedClassKey, FeedStyleClasses, TabLargeStyle, TimelineClassKey, TimelineStyleClasses } from "assets/jss/common-styles";
import AdvFilter, { AdvFilterCommand, AdvFilterComponent, AdvFilterPicker, AdvFilterResult } from "components/AdvFilter";
import { CmdList, CmdPoll, CmdPost, CmdPublicationApprovedOnly, CmdPublicationExpired, CmdPublicationFuture, CmdPublicationHighlighted, CmdPublicationPendingOnly, CmdPublicationRejectedOnly, CmdPublishEndDate, CmdPublishStartDate, CmdQuestion, CmdWithComments, CmdWithFile, CmdWithImage, CmdWithLikes, CmdWithNewComments, CmdWithNewLikes, CmdWithNewThanks, CmdWithThanks, CmdWithVideo, CommandLabels } from "components/AdvFilter/CommonCommands";
import { AppBarTabs } from "components/AppTabs";
import ButtonOrderBy from "components/Buttons/ButtonOrderBy";
import ButtonResetFilter from "components/Buttons/ButtonResetFilter";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import CountFilter from "components/CountFilter";
import IconCircle from "components/Icons/IconCircle";
import { MuiFilterAppBar, MuiFilterLine, MuiFilterToolbar } from "components/MuiExtras/Filter";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiMenuItemChecked from "components/MuiExtras/MuiMenuItemChecked";
import MuiPushRight from "components/MuiExtras/MuiPushRight";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import LibUtils from "lib/LibUtils";
import { FeedType, PublicationType } from "models/ApiEnums";
import { FeedAttachType, FeedBaseOrderBy, FeedPublicationFilter } from "models/ApiModels";
import queryString from 'query-string';
import * as React from "react";
import { useTranslation, WithTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from "store/app/reducer";
import * as FeedActions from 'store/feed/actions';
import { FeedState } from "store/feed/reducer";
import { ApplicationState } from "store/rootReducer";
import * as SideBarActions from 'store/sidebar/actions';
import CardManager from "views/Timeline/Components/CardManager";
import { ITimelineDispatchProps, TimelineWindowMessageListener } from "views/Timeline/TimelineCommons";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IStateProps {
    feed: FeedState;
    app: AppState;
}

interface IState {
    advFilters: AdvFilterResult[];
    filter: FeedPublicationFilter;
    orderBy: FeedBaseOrderBy;
    orderByMenuAnchorEl: any;
    dialog: any;
}

interface IStateSaved {
    feedType: FeedType;
    state: IState;
}

interface IProps {
    timestamp?: Date;
}

interface IQueryProps {
    nl?: string;
    nc?: string;
    nt?: string;
}

interface IDispatchProps extends ITimelineDispatchProps {
    onGetFeed: (filter: FeedPublicationFilter, orderBy: FeedBaseOrderBy, startIndex: number, endIndex: number) => Promise<any>;
}

type Props = IProps & IStateProps & IDispatchProps & StyledComponentProps<TimelineClassKey | FeedClassKey> & WithSnackbar & WithTranslation & RouteComponentProps<IQueryProps>;

/////////////////////////////////////////////////////////////////////////////////////////////////


interface IRenderMenu {
    category: FeedType;
    onChange: (event: React.ChangeEvent<{}>, value: any) => void;
}

const RenderMenuBar: React.FC<Props & IRenderMenu> = (props) => {
    const { t } = useTranslation();
    return (
        <div className={props.classes.filterTabContainer}>
            <AppBar position="static" color="default" classes={{ root: props.classes.appTabFilterRoot }}>
                <AppBarTabs
                    centered
                    value={props.category}
                    onChange={props.onChange}
                >
                    <Tab
                        value={FeedType.MyPublication}
                        label={
                            <span>
                                {
                                    props.app.callouts.findIndex(p => p.feed == FeedType.MyPublication && p.callout === true) > -1 &&
                                    <MuiColor variant="warning"><IconCircle fixedWidth /></MuiColor>
                                }
                                <span>{t("Views.Timeline.TimelinePublications.TabMyPublication")}</span>
                            </span>
                        }
                        style={TabLargeStyle}
                        disabled={props.feed.loading}
                    />

                    <Tab
                        value={FeedType.MyAnswers}
                        label={t("Views.Timeline.TimelinePublications.TabMyAnswers")}
                        style={TabLargeStyle}
                        disabled={props.feed.loading}
                    />

                    <Tab
                        value={FeedType.MyDraft}
                        label={t("Views.Timeline.TimelinePublications.TabMyDraft")}
                        style={TabLargeStyle}
                        disabled={props.feed.loading}
                    />
                </AppBarTabs>
            </AppBar>
        </div>
    );
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TimelinePublicationsComponent extends React.PureComponent<Props, IState> {

    private advFilterRef: AdvFilterComponent;
    private saveState: IStateSaved[] = [];
    private wmm: TimelineWindowMessageListener;

    constructor(props: Props) {
        super(props);

        this.saveState.push({ feedType: FeedType.MyPublication, state: this.recoverState(FeedType.MyPublication) });
        this.saveState.push({ feedType: FeedType.MyDraft, state: this.recoverState(FeedType.MyDraft) });
        this.saveState.push({ feedType: FeedType.MyAnswers, state: this.recoverState(FeedType.MyAnswers) });

        this.state = this.saveState[0].state;
    }

    ///
    private saveCurrentState() {
        var item = this.saveState.find(p => p.feedType == this.state.filter.category);
        item.state = this.state;
    }

    ///
    private recoverState(feedType: FeedType): IState {

        var item = this.saveState.find(p => p.feedType == feedType);

        if (item == null)
            return {
                advFilters: [],
                filter: {
                    category: feedType,
                    searchText: null,
                    publicationTypes: null,
                    attachTypes: null,
                    withLikes: null,
                    withThanks: null,
                    withComments: null,
                    withNewLikes: null,
                    withNewThanks: null,
                    withNewComments: null,
                    endDate: null,
                    startDate: null
                },
                orderBy: FeedBaseOrderBy.Default,
                orderByMenuAnchorEl: null,
                dialog: null
            } as IState;

        return item.state;
    }


    //#region FILTER

    ///
    private get commands(): AdvFilterCommand[] {
        const cmdLabels = CommandLabels();
        return [
            { keyword: CmdWithLikes, displayName: cmdLabels[CmdWithLikes], group: 1 },
            { keyword: CmdWithComments, displayName: cmdLabels[CmdWithComments], group: 1 },
            { keyword: CmdWithThanks, displayName: cmdLabels[CmdWithThanks], group: 1 },
            { keyword: CmdWithNewLikes, displayName: cmdLabels[CmdWithNewLikes], group: 1 },
            { keyword: CmdWithNewComments, displayName: cmdLabels[CmdWithNewComments], group: 1 },
            { keyword: CmdWithNewThanks, displayName: cmdLabels[CmdWithNewThanks], group: 1 },

            { keyword: CmdWithVideo, displayName: cmdLabels[CmdWithVideo], group: 2 },
            { keyword: CmdWithImage, displayName: cmdLabels[CmdWithImage], group: 2 },
            { keyword: CmdWithFile, displayName: cmdLabels[CmdWithFile], group: 2 },

            { keyword: CmdPost, displayName: cmdLabels[CmdPost], group: 3 },
            { keyword: CmdQuestion, displayName: cmdLabels[CmdQuestion], group: 3 },
            { keyword: CmdList, displayName: cmdLabels[CmdList], group: 3 },
            { keyword: CmdPoll, displayName: cmdLabels[CmdPoll], group: 3 },

            { keyword: CmdPublishStartDate, displayName: cmdLabels[CmdPublishStartDate], picker: AdvFilterPicker.Calendar, group: 4 },
            { keyword: CmdPublishEndDate, displayName: cmdLabels[CmdPublishEndDate], picker: AdvFilterPicker.Calendar, group: 4 },
            { keyword: CmdPublicationHighlighted, displayName: cmdLabels[CmdPublicationHighlighted], group: 4 },
            { keyword: CmdPublicationExpired, displayName: cmdLabels[CmdPublicationExpired], group: 4 },
            { keyword: CmdPublicationFuture, displayName: cmdLabels[CmdPublicationFuture], group: 4 },

            { keyword: CmdPublicationApprovedOnly, displayName: cmdLabels[CmdPublicationApprovedOnly], optionGroup: 1, group: 5 },
            { keyword: CmdPublicationPendingOnly, displayName: cmdLabels[CmdPublicationPendingOnly], optionGroup: 1, group: 5 },
            { keyword: CmdPublicationRejectedOnly, displayName: cmdLabels[CmdPublicationRejectedOnly], optionGroup: 1, group: 5 },
        ];
    }

    ///
    private isFiltered() {
        return !LibUtils.isAllPropertiesWithValue(this.state.filter, null, ["category"]);
    }

    ///
    private applyOrder = (orderBy: FeedBaseOrderBy) => {
        this.setState({ orderBy, orderByMenuAnchorEl: null }, () => this.props.onFeedReset());
    };

    ///
    private handleTabSelection = (event: React.ChangeEvent<{}>, value: any) => {
        if (this.advFilterRef) this.advFilterRef.closeFilter();
        this.saveCurrentState();
        this.setState(this.recoverState(value));
        this.props.onFeedReset();
    };

    ///
    private clearFilter(): Partial<FeedPublicationFilter> {
        return {
            searchText: null,
            publicationTypes: null,
            attachTypes: null,
            withLikes: null,
            withThanks: null,
            withComments: null,
            withNewLikes: null,
            withNewThanks: null,
            withNewComments: null,
            endDate: null,
            startDate: null,
            highlighted: null,
            expired: null,
            future: null,
            approvedOnly: null,
            pendingOnly: null,
            rejectedOnly: null
        };
    }

    ///
    private buildFilter(searchText: string, advFilters: AdvFilterResult[]) {
        var filter: Partial<FeedPublicationFilter> = {};

        filter.searchText = searchText.length == 0 ? null : searchText;

        filter.publicationTypes = [];
        if (advFilters.findIndex(x => x.keyword == CmdPost) > -1) filter.publicationTypes.push(PublicationType.Post);
        if (advFilters.findIndex(x => x.keyword == CmdList) > -1) filter.publicationTypes.push(PublicationType.List);
        if (advFilters.findIndex(x => x.keyword == CmdQuestion) > -1) filter.publicationTypes.push(PublicationType.Question);
        if (advFilters.findIndex(x => x.keyword == CmdPoll) > -1) filter.publicationTypes.push(PublicationType.Poll);

        filter.attachTypes = [];
        if (advFilters.findIndex(x => x.keyword == CmdWithVideo) > -1) filter.attachTypes.push(FeedAttachType.Video);
        if (advFilters.findIndex(x => x.keyword == CmdWithImage) > -1) filter.attachTypes.push(FeedAttachType.Image);
        if (advFilters.findIndex(x => x.keyword == CmdWithFile) > -1) filter.attachTypes.push(FeedAttachType.File);

        filter.withLikes = advFilters.findIndex(x => x.keyword == CmdWithLikes) > -1;
        filter.withNewLikes = advFilters.findIndex(x => x.keyword == CmdWithNewLikes) > -1;
        filter.withThanks = advFilters.findIndex(x => x.keyword == CmdWithThanks) > -1;
        filter.withNewThanks = advFilters.findIndex(x => x.keyword == CmdWithNewThanks) > -1;
        filter.withComments = advFilters.findIndex(x => x.keyword == CmdWithComments) > -1;
        filter.withNewComments = advFilters.findIndex(x => x.keyword == CmdWithNewComments) > -1;
        filter.approvedOnly = advFilters.findIndex(x => x.keyword == CmdPublicationApprovedOnly) > -1;
        filter.pendingOnly = advFilters.findIndex(x => x.keyword == CmdPublicationPendingOnly) > -1;
        filter.rejectedOnly = advFilters.findIndex(x => x.keyword == CmdPublicationRejectedOnly) > -1;

        var dt = advFilters.find(x => x.keyword == CmdPublishStartDate);
        filter.startDate = dt ? (dt.value as Date).putStartOfDay() : null;

        dt = advFilters.find(x => x.keyword == CmdPublishEndDate);
        filter.endDate = dt ? (dt.value as Date).putEndOfDay() : null;

        filter.highlighted = advFilters.findIndex(x => x.keyword == CmdPublicationHighlighted) > -1;
        filter.expired = advFilters.findIndex(x => x.keyword == CmdPublicationExpired) > -1;
        filter.future = advFilters.findIndex(x => x.keyword == CmdPublicationFuture) > -1;

        return filter;
    }

    ///
    private handleUpdateFilter = (searchText: string, advFilters: AdvFilterResult[]) => {
        var newFilter = (searchText.length == 0 && advFilters.length == 0)
            ? this.clearFilter()
            : this.buildFilter(searchText, advFilters);

        this.setState(
            {
                advFilters,
                filter: { ...this.state.filter, ...newFilter }
            }, () => this.props.onFeedReset()
        );
    };

    ///
    private renderAdvFilter(): JSX.Element {
        const { orderBy, filter } = this.state;

        const cmds = filter.category == FeedType.MyAnswers
            ? this.commands.filter(p => p.group != 3)
            : this.commands;

        return (
            <MuiFilterAppBar position="static">
                <MuiFilterToolbar variant="dense">
                    <MuiFilterLine>
                        <AdvFilter
                            id="advfilter"
                            commands={cmds}
                            innerRef={(ref) => this.advFilterRef = ref}
                            placeHolder={this.props.t("Common.Filter.Adv.InputPlaceholder")}
                            placeHolderFocus={this.props.t("Common.Filter.Adv.InputPlaceholderFocus")}
                            title={this.props.t("Common.Filter.Adv.InputTitleEnterToFilter")}
                            selectedCommands={this.state.advFilters}
                            onUpdateSelection={this.handleUpdateFilter} />

                        <MuiPushRight>
                            <ButtonOrderBy
                                onClick={
                                    (e) => {
                                        this.setState({ orderByMenuAnchorEl: e.currentTarget });
                                    }
                                }
                            />

                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.orderByMenuAnchorEl}
                                open={this.state.orderByMenuAnchorEl != null}
                                onClose={this.closeOrderBy}
                            >
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostRecent")} value={FeedBaseOrderBy.Default} currentSelection={orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostLiked")} value={FeedBaseOrderBy.Best} currentSelection={orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostViewed")} value={FeedBaseOrderBy.MostViews} currentSelection={orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostCommented")} value={FeedBaseOrderBy.MostComments} currentSelection={orderBy} onClick={this.applyOrder} />
                            </Menu>
                        </MuiPushRight>
                    </MuiFilterLine>
                </MuiFilterToolbar>
            </MuiFilterAppBar>
        );
    }

    ///
    private closeOrderBy = () => {
        this.setState({ orderByMenuAnchorEl: null });
    };

    //#endregion

    ///
    private translateQueryParamsToAdvFilter() {
        const values = queryString.parse(this.props.location.search);
        if (values.nc) this.advFilterRef.addCommand(CmdWithNewComments, null, null);
        if (values.nl) this.advFilterRef.addCommand(CmdWithNewLikes, null, null);
        if (values.nt) this.advFilterRef.addCommand(CmdWithNewThanks, null, null);
    }

    ///
    public componentDidMount() {
        this.props.onFeedReset();
        this.translateQueryParamsToAdvFilter();
        this.wmm = new TimelineWindowMessageListener(this.props.executeFeedMessage);
    }

    ///
    public componentWillUnmount() {
        this.props.onFeedReset();
        this.wmm.dettach();
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if (prevProps.timestamp != this.props.timestamp && !this.props.feed.loading)
            this.props.onFeedReset();
    }

    ///
    public render() {
        const { classes, feed, feed: { lastError, totalRecords, loading }, snackbar } = this.props;
        const { filter, orderBy } = this.state;

        return (
            <div>
                <RenderMenuBar {...this.props} category={filter.category} onChange={this.handleTabSelection} />

                <div className={classes.timelineContainer}>

                    {this.state.dialog}

                    {
                        (totalRecords > 0 || this.isFiltered()) &&
                        <MuiContainer margin="normal">
                            {this.renderAdvFilter()}
                        </MuiContainer>
                    }

                    {
                        totalRecords > 0 &&
                        <MuiContainer margin="normal">
                            <CountFilter
                                count={totalRecords}
                                filtered={this.isFiltered()}
                                resource="Common.Feed.Filter.PublicationResultText"
                                filteredResource="Common.Feed.Filter.PublicationFilteredResultText"
                                onResetFilter={() => this.advFilterRef.resetFilter()}
                            />
                        </MuiContainer>
                    }

                    <CardManager
                        classes={classes}
                        feedType={filter.category}
                        feed={feed}
                        snackbar={snackbar}
                        onExpandPublication={this.props.onExpandPublication}
                        onPublishPublication={this.props.onPublishPublication}
                        onRemovePublication={this.props.onRemovePublication}
                        onReloadPublication={this.props.onReloadPublication}
                        onUpdatePublication={this.props.onUpdateFeedData}
                        onSidebarResetRequest={this.props.onSidebarResetRequest}
                        onRemoveFromFeed={this.props.onRemoveFromFeed}
                        onGetFeed={(startIndex: number, endIndex: number) => { return this.props.onGetFeed(this.state.filter, orderBy, startIndex, endIndex); }}
                        onFeedReset={() => this.props.onFeedReset()}
                    />

                    {
                        lastError != null
                            ? <RequestErrorReport error={lastError} />
                            : totalRecords == 0 && !loading && !this.isFiltered()
                                ? (
                                    <MuiMessageBox
                                        variant="info"
                                        message={this.props.t("Common.Feed.Filter.PublicationResultText_zero")}
                                    />
                                )
                                : totalRecords == 0 && !loading && this.isFiltered()
                                    ? (
                                        <MuiMessageBox
                                            variant="warning"
                                            action={<ButtonResetFilter color="warning" onClick={() => this.advFilterRef.resetFilter()} />}
                                            message={this.props.t("Common.Feed.Filter.PublicationFilteredResultText_zero")}
                                        />
                                    )
                                    : null
                    }

                </div>
            </div>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////

function mapStateToProps(state: ApplicationState): IStateProps {
    return {
        feed: state.feed,
        app: state.app
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<ApplicationState, void, Action<any>>, ownProps: IProps): IDispatchProps {
    const action = new FeedActions.PublicationsFeedAction();

    return {
        onAddPublication: (publicationId) => dispatch(action.addPublication(publicationId)),
        onReloadPublication: (uid, publicationId) => dispatch(action.reloadPublication(uid, publicationId)),
        onRemovePublication: (uid, publicationId, publicationType) => dispatch(action.removePublication(uid, publicationId, publicationType)),
        onExpandPublication: (uid, publicationId) => dispatch(action.getPublicationFullContent(uid, publicationId)),
        onUpdateFeedData: (newItemDto) => dispatch(action.updateFeedData(newItemDto)),
        onRemoveFromFeed: (uid, publicationId) => dispatch(action.removeFeedData(uid, publicationId)),
        onFeedReset: () => dispatch(action.feedReset()),
        onIgnoreActionRequest: (uid, publicationId, actionId) => dispatch(action.ignoreActionRequest(uid, publicationId, actionId)),

        onGetFeed: (filter, orderBy, startIndex, endIndex) => dispatch(action.getFeed(filter, orderBy, startIndex, endIndex)),

        onSidebarResetRequest: () => dispatch(SideBarActions.reset()),

        executeFeedMessage: (messageType) => action.executeFeedMessage(messageType, dispatch)
    };
}

const withAllStyles = withStyles(
    (theme) => ({
        ...TimelineStyleClasses(theme),
        ...FeedStyleClasses(theme),
    }),
    { withTheme: true },
);

const Timeline = connect<IStateProps, IDispatchProps>(mapStateToProps, mapDispatchToProps)(withRouter(withSnackbar(withTranslation()(withAllStyles(TimelinePublicationsComponent)))));

///////////////////////////////////////////////////////////////////////////

const TimelinePublications: React.FC<Props> = () => {
    return (
        <Timeline
            timestamp={new Date()}
        />
    );
};

export default TimelinePublications;